<template>

    <CRow>
        <CCol col="12" lg="10">
            <CCard>
                <CCardHeader>
                    <strong>{{ dish.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <CRow class="pl-3 pb-3" />
                        <CRow class="pl-3 pb-3">
                            <CCol sm="4">
                                <CSelect
                                    horizontal
                                    :options="ingredientsOptions"
                                    :value.sync="selectedIngredient"
                                    placeholder="Выберите ингредиент..."
                                />
                            </CCol>
                            <CCol sm="8">
                                <CButton
                                    color="primary"
                                    class="ml-3"
                                    @click="addIngredient">Добавить</CButton>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <CInput
                                    v-model.number="limit"
                                    horizontal
                                    label="Лимит ингредиентов"
                                    placeholder="Введите лимит группы"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="pl-3">
                            <table class="table">
                                <thead>
                                    <th>&nbsp;</th>
                                    <th>Название</th>
                                    <th>Вес</th>
                                    <th>Цена</th>
                                    <th>&nbsp;</th>
                                </thead>
                                <draggable v-model="ingredients" tag="tbody">
                                    <tr v-for="ingredient in ingredients" :key="ingredient.title">
                                        <td><CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="handle" /></td>
                                        <td>{{ ingredient.title }}</td>
                                        <td>{{ ingredient.weight }}</td>
                                        <td>{{ ingredient.price }}</td>
                                        <td><CButton @click="removeIngredient(ingredient.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton></td>
                                    </tr>
                                </draggable>
                            </table>
                        </CRow>
                    </template>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';

    export default {

        name: 'DishIngredients',

        components: {
            draggable
        },

        icons: {
            cilCursorMove,
            cilTrash
        },
  
        data () {
            return {
                loading: true,
                restaurant: {},
                dish: {},
                ingredients: [],
                allIngredients: [],
                selectedIngredient: null,
                limit: null,
            }
        },
    
        computed: {
            ingredientsOptions: function() {
                const ingredientsOptions = [];
                this.allIngredients.forEach(ingredient => {
                    ingredientsOptions.push({
                        value: ingredient.id,
                        label: ingredient.title + ' - ' + ingredient.price + ' руб. - ' + ingredient.weight + ' гр.'
                    });
                });
                return ingredientsOptions;
            }
        },
  
        async mounted() {
            const restaurantId = parseInt(this.$route.params.id);
            const id = parseInt(this.$route.params.dish_id);
            await Vue.axios.get('/restaurants/' + restaurantId)
                .then(resp => {
                    this.restaurant = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            await Vue.axios.get('/restaurants/' + restaurantId + '/dishes/' + id)
                .then(resp => {
                    this.dish = resp.data;
                    this.limit = resp.data?.ingridients_limit || null;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            await Vue.axios.get('/restaurants/' + restaurantId + '/dishes/get-ingredients/' + id)
                .then(resp => {
                    this.ingredients = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            await Vue.axios.get('/restaurants/' + restaurantId + '/ingredients')
                .then(resp => {
                    this.setAllIngredients(resp.data);
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            this.loading = false;
        },

        methods: {

            save() {
                const ingredientsToSave = [];
                let index = 0;
                this.ingredients.forEach(ingredient => {
                    ingredient.position = ++index;
                    ingredientsToSave.push(ingredient);
                });
                Vue.axios.post('/restaurants/' + this.restaurant.id +'/dishes/ingredients/' + this.dish.id, { ingredients: ingredientsToSave })
                    .then(resp => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
                this.dish.ingridients_limit = this.limit;
                Vue.axios.post('/restaurants/' + this.restaurant.id + '/dishes/update/' + this.dish.id, this.dish)
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            setAllIngredients(ingredients) {
                const _allIngredients = [];
                ingredients.forEach(ingredient => {
                    if(this.addIngredientOption(ingredient.id)) {
                        _allIngredients.push({
                            id: ingredient.id,
                            title: ingredient.title,
                            weight: ingredient.weight,
                            price: ingredient.price,
                            position: ingredient.position
                        });
                    }
                });
                this.allIngredients = _allIngredients;
            },

            addIngredientOption(id) {
                let contains = false;
                for(var i = 0; i < this.ingredients.length; i++) {
                    if(this.ingredients[i].id === id) {
                        contains = true;
                    }
                }
                return !contains;
            },

            addIngredient() {
                for(var i = 0; i < this.allIngredients.length; i++) {
                    if(this.selectedIngredient === this.allIngredients[i].id) {
                        this.ingredients.push({
                            id: this.allIngredients[i].id,
                            title: this.allIngredients[i].title,
                            price: this.allIngredients[i].price,
                            weight: this.allIngredients[i].weight,
                            position: 0
                        });
                        delete this.allIngredients[i];
                        break;
                    }
                }
                this.setAllIngredients(this.allIngredients);
            },

            removeIngredient(id) {
                const _ingredients = []; 
                for(var i = 0; i < this.ingredients.length; i++) {
                    if(id != this.ingredients[i].id) {
                        _ingredients.push(this.ingredients[i]);
                    }
                }
                this.ingredients = _ingredients;
            },

            goBack() {
                this.$router.push({ path: '/restaurants/' + this.restaurant.id + '/dishes/' + this.dish.id })
            }
        }
    }

</script>
<style scoped>
.handle {
  cursor: pointer;
}
</style>
